import { Grid } from '@mui/material';
import RoundedImg from './RoundedImg'
import { useCustomContext } from './ContextHook';
import MutualService from '../service/MutualService';
import { useEffect, useState } from 'react';
import {convertDateFormat} from '../utils/dates'

const Profile = () => {
    const context = useCustomContext()
    const [startDate, setStartDate] = useState('')


    useEffect(() => {
        const getActivesubscriptions = async () => {
            const result = await MutualService.getActiveSubscription(context.user.uuid)
            if(result.active_subscription !== null){
                setStartDate(result.active_subscription.created_at)
            }
            else{
                setStartDate('Error')
            }
        }
        getActivesubscriptions()
    }, [context.user.uuid])

    const widthNumberXs = context.width < 786 ? (context.width < 300 ? 12 : 6) : 6

    return(
        <Grid item container justifyContent='center' style={{margin: '15px 0px'}}>
            <Grid 
                container 
                item 
                justifyContent="center" 
                flexDirection={context.width <= 320 ? 'column' : 'row'}
                alignItems={context.width <= 320 ? 'center' : 'normal'}
                flexWrap='nowrap' 
                style={{minWidth: '280px'}}
                xs={widthNumberXs} 
            >
                <Grid xs={5} item>
                    <RoundedImg/>
                </Grid>

                <Grid xs={5} item container flexDirection='column' justifyContent="center">
                    <p style={{fontSize: '20px', fontWeight: '700'}}>{context.user.firstName}</p>

                    {
                        startDate.length === 0 
                        ?
                        null
                        :
                        <p style={{fontSize: '16px', fontWeight: '400', color: '#444444'}}>Start Date: {convertDateFormat(startDate)}</p>
                    }
                </Grid>
            </Grid>
        </Grid>

    )
}


export default Profile;
